<template>
  <header class="search header">
    <div
      class="header__container tw-flexbox-row-align-center-justify-between"
    >
      <nav
        class="left-column tw-flexbox-row-justify-between"
      >
        <router-link
          :to="logoUrl"
          @click.native="handleLogoClicked"
        >
          <slot
            name="simple-logo"
          >
            <component
              :is="componentLogo"
              :class="logoClasses"
              :alt="logoAlt"
            />
          </slot>
        </router-link>
        <div
          class="tw-whitespace-nowrap
          tw-md:tw-pl-4
          tw-xl:tw-pl-8
        tw-text-black-670
          header-title"
        />
      </nav>
      <div
        class="right-column
          tw-flexbox-row-align-center-justify-between"
      >
        <acv-search-settings-dropdown-menu
          :full-name="currentUserFullName || email"
          :dealership-name="dealershipName"
          :has-outstanding-auctions="hasOutstandingAuctions"
        />
      </div>
    </div>
  </header>
</template>

<script>
import { AcvAuctionsPrimaryLightSvg } from '@acv/shared-vuejs';
import AcvHeader from '@/components/Header.vue';
import Analytics from '@/mixins/Analytics';
import AcvSearchSettingsDropdownMenu from '@/components/Search/SearchSettingsDropdownMenu.vue';
import titlesHubSvg from '@/assets/svg/title-hub.svg';

export default {
  name: 'AcvSimplifiedHeader',
  components: {
    AcvSearchSettingsDropdownMenu,
    AcvAuctionsPrimaryLightSvg,
    titlesHubSvg,
  },
  extends: AcvHeader,
  mixins: [
    Analytics,
  ],
  computed: {
    pageTitle() {
      return this.$route.meta.headerPageTitle || null;
    },
    logoUrl() {
      return '/myacv';
    },
    componentLogo() {
      if (this.isDigitalClerking) {
        return 'titlesHubSvg';
      }
      return 'AcvAuctionsPrimaryLightSvg';
    },
    isDigitalClerking() {
      const matchedRoute = this.$route?.matched?.find((route) => route.name === this.$route.name);
      return matchedRoute?.parent?.name === 'MyAcvDigitalClerking';
    },
    logoClasses() {
      return {
        'titles-logo': this.isDigitalClerking,
      };
    },
    logoAlt() {
      return this.$route.meta.logoAlt || 'The logo of ACV Auctions';
    },
  },
  methods: {
    handleLogoClicked() {
      if (this.isDigitalClerking) {
        this.track(this.eventNames.titleHub.titlesHeaderClicked, {
          dealer_id: this.currentUser.defaultDealerId,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/scss/search/fonts';

::v-deep .header-title {
  font-size: 24px;
  padding-left: 20px;
  margin-top: 12px;
}

.header {
  width: 100%;
  border-bottom: 1px solid #ddd;
  height: 58px;
  position: fixed;
  z-index: 6;

  @apply tw-bg-white;

  &__container {
    padding: 0 30px;

    .left-column {
      .header-links {
        margin: auto;
        height: 100%;

        a {
          padding: 1rem 0;
          display: inline-block;
          cursor: pointer;
          border-bottom: 2px solid transparent;

          &:hover {
            text-decoration: none;

            @apply tw-border-primary-base;
            @apply tw-border-b-2;
            @apply tw-text-black-670;
          }

          &.active {
            @apply tw-border-primary-base;
            @apply tw-border-b-2;
            @apply tw-text-primary-base;
          }
        }
      }

      .nav-badge {
        @apply tw-bg-primary-base;
        @apply tw-text-white;

        border-radius: 2px;
        font-size: 12px;
        padding: 3px;
        margin-left: 6px;
        position: relative;
        bottom: 2px;
      }
    }

    .right-column {
      margin-top: 9px;

      .notifications-menu {
        margin-right: 0.25rem;

        &.is-search ::v-deep .notification-badge {
          top: 0.75rem;
          right: 0.75rem;
        }
      }
    }
  }

  .titles-logo {
    margin-top: 15px;
  }
}
</style>
